import { Component, computed, inject, input, output, signal } from '@angular/core';
import { I18nService, UiService, Location, NavButtonComponent } from '@lp-ui-lib';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzIconModule } from 'ng-zorro-antd/icon';

// If you use ngx-extended-pdf-viewer as standalone, add its module too (or keep in a module).
// import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [
    NzCardModule,
    NzAlertModule,
    NzAvatarModule,
    NzModalModule,
    NzIconModule,
    NavButtonComponent,
  ],
  templateUrl: './card.html',
  styleUrls: ['./card.scss'],
})
export class CardComponent {
  plant = input<Location | null>(null);
  fine = input<boolean>(false);
  modal = input<boolean>(false);
  detail = input<boolean>(false);
  closeBtn = input<boolean>(false);
  showLayer = input<boolean>(false);
  isDisabled = input<boolean>(false);
  showsArchived = input<boolean>(false);

  closeEvent = output<void>();
  nav = output<void>();

  private ui = inject(UiService);
  public i18n = inject(I18nService);

  svg_icon_top = 'icons:arrow-right-up';
  modalOpen = signal<boolean>(false);
  srclink = signal<string | null>(null);

  isMobile = computed(() => this.ui.IsMobile());
  isTablet = computed(() => this.ui.IsTablet());
  isDesktop = computed(() => this.ui.IsDesktop());

  assetsCount = computed(() => {
    const p = this.plant();
    if (!p) return 0;

    const archived = this.showsArchived() ? 0 : p.Archived.length;
    return p.Assets.length - archived - p.AssetsWithoutSensors.length;
  });

  hasOnlyWorkingAndNoIssues = computed(() => {
    const p = this.plant();
    if (!p) return false;
    return (
      p.Critical.length === 0 &&
      p.Warning.length === 0 &&
      p.InActive.length === 0 &&
      p.Working.length > 0
    );
  });

  hasAnyIssues = computed(() => {
    const p = this.plant();
    if (!p) return false;
    return p.Critical.length > 0 || p.Warning.length > 0 || p.InActive.length > 0;
  });

  onNav() {
    this.nav.emit();
  }

  openBuildingPreview(buildingPlan: string | null | undefined) {
    if (!buildingPlan) return;
    this.srclink.set(buildingPlan);
    this.modalOpen.set(true);
  }

  openNewTab() {
    const url = this.plant()?.buildingPlan;
    if (url) window.open(url, '_blank', 'noreferrer');
  }

  cancelClick() {
    this.modalOpen.set(false);
  }
}
